import {Center, Spinner, SpinnerProps} from '@chakra-ui/react';

export const Loader = (props: SpinnerProps) => (
  <Center flex={1}>
    <Spinner speed="0.6s" emptyColor="gray.100" color="green.400" size="lg" {...props} />
  </Center>
);
